// extracted by mini-css-extract-plugin
export default {"root":"UnubpA","visually-hidden":"sCoUtZ","visuallyHidden":"sCoUtZ","empty":"Nhun_t","link":"HKm7tj"};